module.exports = __webpack_public_path__ + "img/sains.045880cf.png";